import React from "react";

function Dot({ ok, warn }) {
  return <span className={`admin-status-dot ${ok ? "is-on" : warn ? "is-warn" : "is-off"}`} />;
}

export default function AdminStatusPanel({ status }) {
  const s = status || {};
  const rows = [
    ["Backend", s.backend === "online", false],
    ["MongoDB", s.mongo === "connected", false],
    ["Anthropic", s.anthropic === "configured", false],
    ["OANDA", s.oanda === "configured", s.oanda !== "configured"],
    ["TwelveData", s.twelvedata === "configured", s.twelvedata !== "configured"],
    ["Alpha Vantage", s.alphavantage === "configured", s.alphavantage !== "configured"],
    ["PDF Engine", s.pdf === "ready", false],
    ["Compliance Guard", s.compliance_guard === "active", false],
  ];
  return (
    <aside className="admin-status-panel" data-testid="admin-status-panel">
      <div className="admin-status-panel__title">OPERATIONAL READINESS</div>
      <ul className="admin-status-list">
        {rows.map(([label, ok, warn]) => (
          <li key={label} className="admin-status-row">
            <Dot ok={!!ok} warn={!!warn && !ok} />
            <span className="admin-status-row__label">{label}</span>
            <span className={`admin-status-row__value ${ok ? "is-on" : warn ? "is-warn" : "is-off"}`}>
              {ok ? "READY" : warn ? "KEYS REQUIRED" : "OFFLINE"}
            </span>
          </li>
        ))}
      </ul>
    </aside>
  );
}
